import React from 'react'
import Header from '../Components/Header'
import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import { P, SectionHeading } from '../../../Styles/style'


import off from "../../../../assets/images/off.png"
import offer from "../../../../assets/images/offer.png"
import burn from "../../../../assets/images/burn.png"
import tokenimg from "../../../../assets/images/tokenimg.png"
import { useTheme } from '@emotion/react'

import arrow from "../../../../assets/images/whitearrow.png"
const SectionWrapper = styled.div`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
place-content: center;
flex-direction: column;
align-items: center;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    /* padding: ${(props) => (props.p799 ? props.p799 : "30px 0")}; */
  }
  @media screen and (max-width: 599px) {
    /* padding: ${(props) => (props.p599 ? props.p599 : "30px 0")}; */
  }
`;
const ConnectButt = styled.a`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
align-items: center;
text-align: center;
place-content: center;
margin: ${(props) => (props.m ? props.m : "")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textSecondary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textSecondary)};
@media screen and (max-width:599px){
  /* padding: ${(props) => (props.p ? props.p : "7px 10px")}; */
  /* max-width: ${(props) => (props.mw ? props.mw : "50%")}; */

}
`
const BtnDIv = styled.div`
display: flex;
align-items:center ;
gap: 23px;
padding: 40px 0;
@media screen and (max-width:699px){

  display: inline-grid;
}
`
const MainGrid = styled(Grid)`
padding: 80px 0 30px;
justify-content: center;
text-align: LEFT;
`
const GridImg = styled(Grid)`
text-align-last: right;
`
const GridText = styled(Grid)`
/* padding: 80px 0 0; */
`
const LearnBuutt = styled.a`
    border: 1px solid  ${(props) => props.theme.textPrimary} ;
color: ${(props) => props.theme.textPrimary} ;
padding: 7px 20px;
text-decoration: none;
`
const MetAMskimg = styled.img`
   width:100%;
   max-width: 350px;
`
const S1_Token = () => {
    const theme = useTheme()
    return (
        <div>
            <Header heading="The $Incognito Token" para="Explore the utility." />
            <Container maxWidth="xl">

                <MainGrid container rowGap={2}>
                    <GridText item xs={12} md={5} data-aos="fade-up"
                        data-aos-anchor-placement="top-bottom"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="1000">
                        <SectionHeading data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="300"
                            data-aos-offset="0"
                            data-aos-duration="1000">
                            Token Purposes
                        </SectionHeading>

                        <P data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="300"
                            data-aos-offset="0"
                            data-aos-duration="1000">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</P>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <img src={off} />
                                <P><b>Fee discount for token holders</b></P>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <img src={burn} />
                                <P><b>Token burn from 50% of the fees</b></P>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <img src={offer} />
                                <P><b>Exclusive offers and beta access-first
                                    functionality to token holders</b></P>
                            </Grid>
                        </Grid>
                    </GridText>

                    {/* <Grid item xs={2} /> */}
                    <GridImg item xs={12} md={5}
                        data-aos="zoom-in"
                        // data-aos-anchor-placement="top-bottom"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="1000">
                        <MetAMskimg src={tokenimg} />
                    </GridImg>
                </MainGrid>
            </Container>
            <div>
                <SectionWrapper p="6rem 0 5rem" bgcolor={theme.bgTertiary}>
                    <SectionHeading align="center" color={theme.textSecondary} data-aos="fade-zoom-in"
                        data-aos-easing="ease-in"
                        data-aos-delay="300"
                        data-aos-offset="0"
                        data-aos-duration="1000">Important Links</SectionHeading>
                    <BtnDIv>
                        <ConnectButt target="blank" href="#" bgcolor={theme.textPriamry} data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="400"
                            data-aos-offset="0"
                            data-aos-duration="1000">Uniswap &nbsp;<img src={arrow} /></ConnectButt>
                        <ConnectButt target="blank" href="#" bgcolor={theme.textPriamry} data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="600"
                            data-aos-offset="0"
                            data-aos-duration="1000">Dextool &nbsp;<img src={arrow} /></ConnectButt>
                        <ConnectButt target="blank" href="#" bgcolor={theme.textPriamry} data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="800"
                            data-aos-offset="0"
                            data-aos-duration="1000">Etherscan &nbsp;<img src={arrow} /></ConnectButt>
                        <ConnectButt target="blank" href="#" bgcolor={theme.textPriamry}
                            data-aos="zoom-in"
                            data-aos-easing="ease-in"
                            data-aos-delay="1000"
                            data-aos-offset="0"
                            data-aos-duration="1000">Coinmarketcap &nbsp;<img src={arrow} /></ConnectButt>
                    </BtnDIv>

                </SectionWrapper>
            </div>
        </div>
    )
}

export default S1_Token